import { Deserializable } from '../../../lib/models/deserializable';

export class PropertyOccupant implements Deserializable {
  public PropertyOccupantID: number;
  public DateOfBirth?: Date;
  public Name: string;
  public RelationshipWithApplicantCode: string;
  public ApplicationNumber?: number;
  public RelationshipToYouDetails: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
